"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONLY_REQUESTED = exports.ANY_CONTENT = void 0;
exports.ANY_CONTENT = 'ANY_CONTENT';
exports.ONLY_REQUESTED = 'ONLY_REQUESTED';
